import HttpError from "../../interfaces/api/http-error";
import ValidationResult from "../../interfaces/api/validation-result";

export const isIValidationResultArray = (array: any): array is ValidationResult[] => {
  return Array.isArray(array) && array.every((v) => "isValid" in v && "error" in v);
};

const getSaveErrorMessages = (error: HttpError | ValidationResult[] | null): string[] => {
  if (isIValidationResultArray(error)) {
    return error.filter((e) => !e.isValid && e.error != null).map((e) => e.error!);
  } else if (error != null) {
    return [error.message];
  }
  return [];
};

export default getSaveErrorMessages;